/*
  Avoid duplication of controls, settings and others
  Removing external controls, settingsSections and cleaning up CSS Template before sending to PHP

  PHP will re-add them all back on each render otherwise
 */

import { BuilderElement } from "@/types/elements";
import defensiveCopy from "@/util/defensive-copy";
import { objectGetTypedKeys } from "@/util/type-assertions";

export const getElementWithoutExternalValues = (elementArg: BuilderElement) => {
  const element = defensiveCopy(elementArg);

  const cleanElement = getElementWithoutExternalControls(element);

  cleanElement.controls.settingsSections = [];
  // Delete everything after '{#%---' which is the delimiter for universal twig CSS
  cleanElement.cssTemplate = cleanElement.cssTemplate.split("\n{#%---")[0];

  if (cleanElement.dynamicPropertyPaths) {
    cleanElement.dynamicPropertyPaths =
      cleanElement.dynamicPropertyPaths.filter(
        prop => !prop.path.startsWith("settings.")
      );
  }

  return cleanElement;
};

// Filter out all external controls (like AOS, motion effects, etc)
function getElementWithoutExternalControls(elementArg: BuilderElement) {
  const element = defensiveCopy(elementArg);

  objectGetTypedKeys(element.controls).forEach(key => {
    element.controls[key] = element.controls[key].filter(
      control => !control.options.isExternal
    );
  });

  return element;
}
